import View from '@modul-connect/shared/components/atoms/view'
import { Fade, Modal } from '@mui/material'
import modal from '@modul-connect/shared/components/atoms/modal'
import { H1 } from '@modul-connect/shared/components/atoms/text'
import theme from '@modul-connect/shared/theme'
import Button from '@modul-connect/shared/components/atoms/button'
import TableWidget from '@modul-connect/shared/components/molecules/tableWidget'
import { getTemplateColumns, template_columns } from './temperatureReportDetails/log_columns'
import { useState } from 'react'
import { ModalAlertBanner } from '../../fleet/teams/modalAlertBanner'
import { useTranslation } from 'react-i18next'

export const SelectTemplateModal = ({openModal, onClose, templates, onAdd, failedItems, disabled}) => {
  const [selectedTemplate, setSelectedTemplate] = useState(null)

  const {t} = useTranslation()
  
  const templateColumns = getTemplateColumns(t)
  
  const handleTemplateClick = (id) => {
    const clickedTemplate = templates.find(t => t.id === id)
    if (!clickedTemplate) return
  
    if (selectedTemplate?.id === id) {
      setSelectedTemplate(null)
    } else {
      setSelectedTemplate(clickedTemplate)
    }
  }

  const handleSave = () => {
    if (selectedTemplate) {
      onAdd(selectedTemplate.id, selectedTemplate.templateName)
    }
  }

  return (
    <Modal
      open={openModal}
      onClose={(event, reason) => {
  
        onClose()
      }}
    >
      <Fade in={openModal}>
        <div>
          <View extend={{
            ...modal.container,
            width: '50%',
            height: '80%',
            position: 'absolute',
            top: '8%',
            left: '50%',
            transform: 'translateX(-50%)',
            '@media (max-width: 1025px)': {
              width: '94%',
              left: '50%',
              right: 'auto',     
              transform: 'translateX(-50%)',
            },
          }}>
            <View extend={modal.header}>
              <H1 text={t('climateSystem.settings.addTemplateToVehicles')}/>
                {failedItems.length > 0 ?
                  <ModalAlertBanner text={`Template could not be added to ${failedItems}, press cancel and please try again.`}/>
                     : ''
                }
            </View>
            <View extend={{
              ...modal.content,
              maxHeight: '60vh',      
              overflowY: 'auto',
            }}>
                <TableWidget
                  data={templates}
                  columns={templateColumns}
                  totalItems={templates.length}
                  defaultSort="name"
                  searchStr={''}
                  rowsOptions={templates.length > 0 ? [1000]: undefined}          
                  themes={{ device: 'desktop' }}
                  extend={{ paddingTop: 10 }}
                  isSortable={false}
                  pagination={templates.length > 0 ? false : true}
                  selectedRows={selectedTemplate ? [selectedTemplate.id] : []}
                  onClickRow={(_, id) => handleTemplateClick(id)}
                />
             
            </View>
            <View style={{ height: 60, borderTop: `1px solid ${ theme.colors.lightGrey }`, display: 'flex', justifyContent: 'flex-end', flexDirection: 'row' }}>
               <View style={{ display: 'flex', flexDirection: 'row'}}>
                <Button noBg cancel onClick={() => {
                  onClose()
                }}>
                  {t('cancel')}
                </Button>
                {/* Todo- add retry logic for adding failed templates again */}
                <Button disabled={disabled || !selectedTemplate || failedItems.length} noBg noPadding onClick={handleSave}>
                  {t('save')}
                </Button>
              </View>
            </View>
          </View>
        </div>
      </Fade>
    </Modal>
  )
}